/** Phase 4 message files, one per task so parallel builders never share a file (docs/PHASE-4-PLAN.md). */
import { archEnGB } from './arch.js';
import { c5EnGB } from './c5.js';
import { c6EnGB } from './c6.js';
import { c7EnGB } from './c7.js';
import { c8EnGB } from './c8.js';
import { c9EnGB } from './c9.js';
import { fx1EnGB } from './fx1.js';
import { fx5EnGB } from './fx5.js';
import { l4EnGB } from './l4.js';
import { s41EnGB } from './s41.js';
import { s41bEnGB } from './s41b.js';
import { s42EnGB } from './s42.js';
import { s43EnGB } from './s43.js';
import { s44EnGB } from './s44.js';
import { s45EnGB } from './s45.js';
import { s45bEnGB } from './s45b.js';
import { s46aEnGB } from './s46a.js';
import { s46bEnGB } from './s46b.js';
import { s47EnGB } from './s47.js';
import { s47bEnGB } from './s47b.js';
import { smsEnGB } from './sms.js';
import { s48EnGB } from './s48.js';
import { s49EnGB } from './s49.js';
import { s50EnGB } from './s50.js';
import { s51EnGB } from './s51.js';
import { s52EnGB } from './s52.js';
import { s53EnGB } from './s53.js';
import { s54EnGB } from './s54.js';
import { w24EnGB } from './w24.js';
import { w25EnGB } from './w25.js';
import { w26EnGB } from './w26.js';
import { w27EnGB } from './w27.js';
import { w28EnGB } from './w28.js';
import { w29EnGB } from './w29.js';
import { w30EnGB } from './w30.js';
import { w31EnGB } from './w31.js';
import { w32EnGB } from './w32.js';
import { w33EnGB } from './w33.js';
import { k8EnGB } from './k8.js';
import { m7EnGB } from './m7.js';
import { i1EnGB } from './i1.js';
import { tr1EnGB } from './tr1.js';
import { gapWebEnGB } from './gap-web.js';
import { platformTabsEnGB } from './platform-tabs.js';
import { gapKioskEnGB } from './gap-kiosk.js';
import { sec1EnGB } from './sec1.js';
export const phase4EnGB = {
    ...archEnGB,
    ...c5EnGB,
    ...c6EnGB,
    ...c7EnGB,
    ...sec1EnGB,
    ...c8EnGB,
    ...c9EnGB,
    ...fx1EnGB,
    ...fx5EnGB,
    ...l4EnGB,
    ...s41EnGB,
    ...s41bEnGB,
    ...s42EnGB,
    ...s43EnGB,
    ...s44EnGB,
    ...s45EnGB,
    ...s45bEnGB,
    ...s46aEnGB,
    ...s46bEnGB,
    ...s47EnGB,
    ...s47bEnGB,
    ...s48EnGB,
    ...smsEnGB,
    ...s49EnGB,
    ...s50EnGB,
    ...s51EnGB,
    ...s52EnGB,
    ...s53EnGB,
    ...s54EnGB,
    ...w24EnGB,
    ...w25EnGB,
    ...w26EnGB,
    ...w27EnGB,
    ...w28EnGB,
    ...w29EnGB,
    ...w30EnGB,
    ...w31EnGB,
    ...w32EnGB,
    ...w33EnGB,
    ...k8EnGB,
    ...m7EnGB,
    ...i1EnGB,
    ...tr1EnGB,
    ...gapWebEnGB,
    ...platformTabsEnGB,
    ...gapKioskEnGB,
};
//# sourceMappingURL=index.js.map